import { GridItem, Textarea } from '@chakra-ui/react';
import { ChangeEventHandler } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Field } from '@/components';
import { trans } from '@/i18n';

interface IProps {
  span?: number | 'auto';
  name: string;
  label: string;
  disabled?: boolean;
  hidePlaceholder?: boolean;
  placeholder?: string;
  isPassword?: boolean;
  control?: Control<any>;
  errors: any;
  width?: string | number;
  value?: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement> | undefined;
  childName?: string;
  childIndex?: number;
  onFocus?: () => void;
  onClick?: () => void;
  className?: string;
  rows?: number;
}

function BaseTextarea(props: IProps) {
  const gridProps: any = {
    colSpan: props.span || 'auto',
  };
  if (props.width) gridProps.width = props.width;

  return (
    <GridItem {...gridProps}>
      <Controller
        control={props.control}
        // rules={{
        //   required: true,
        // }}
        // render={({ field: { onChange, onBlur, value } }) => (
        render={({ field }) => {
          return (
            <Field
              label={props.label}
              invalid={
                props.childName && props.childIndex !== undefined
                  ? !!props.errors[props.childName]?.[props.childIndex]
                  : !!props.errors[props.name]
              }
              errorText={
                props.childName && props.childIndex !== undefined
                  ? props.errors[props.childName]?.[props.childIndex]?.message
                  : props.errors[props.name]?.message
              }
              className={props.className}
            >
              <Textarea
                {...field}
                value={props.onChange !== undefined ? props.value : field.value}
                rows={props.rows || 5}
                disabled={props.disabled}
                placeholder={
                  props.hidePlaceholder
                    ? ''
                    : props.placeholder || trans('shared.input', { key: props.label })
                }
                onChange={(e) => {
                  props.onChange?.(e);
                  field.onChange(e);
                }}
                onFocus={props.onFocus}
                onClick={props.onClick}
              />
            </Field>
          );
        }}
        name={props.name}
      />
    </GridItem>
  );
}

export { BaseTextarea };
